import { render } from "./InfoIcon.vue?vue&type=template&id=f642c03c&scoped=true"
import script from "./InfoIcon.vue?vue&type=script&lang=js"
export * from "./InfoIcon.vue?vue&type=script&lang=js"

import "./InfoIcon.vue?vue&type=style&index=0&id=f642c03c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f642c03c"]])

export default __exports__